import type { Deal } from '@paintscout/api'
import { removeAuth0Prefix } from '../../../users/removeAuth0Prefix/removeAuth0Prefix'
import type { DashboardEstimator } from '../..'

export function updateDealOwner({ deal, newOwner }: { deal: Deal; newOwner: DashboardEstimator }): Deal {
  const now = Date.now()
  const currentOwnerId = removeAuth0Prefix(deal.owner?.id || '')
  const newOwnerId = removeAuth0Prefix(newOwner.value)

  if (!!currentOwnerId && currentOwnerId === newOwnerId) {
    return deal
  }

  const [firstName, ...lastNameParts] = newOwner.label.split(' ')
  const lastName = lastNameParts.join(' ')
  return {
    ...deal,
    owner: {
      id: newOwnerId,
      firstName,
      lastName
    },
    updated: now
  }
}
